import {
  Constants,
  useMeeting,
} from "@videosdk.live/react-sdk";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import MicOnIcon from "./icons/Bottombar/MicOnIcon.js";
import MicOffIcon from "./icons/Bottombar/MicOffIcon.js";
import WebcamOnIcon from "./icons/Bottombar/WebcamOnIcon.js";
import WebcamOffIcon from "./icons/Bottombar/WebcamOffIcon.svg";

import MicUnmuteOrange from "./icons/Bottombar/MicUnmuteOrange.svg";
import UnmuteVideo from "./icons/Bottombar/UnmuteVideo.svg";
import HandRaisedIcon from "./icons/Bottombar/HandRaisedIcon.js";
import HandRaisedIconOff from "./icons/Bottombar/HandRaisedIconOff.js";
import MoreIcon from "./icons/Bottombar/HorizentalThreedots.js";
import MoreIconOff from "./icons/Bottombar/HorizentalThreedotsOff.js";
import SmileyIcon from "./icons/Bottombar/SmileyIcon";
import SmileyIconOff from "./icons/Bottombar/SmileyIconOff";
import { sideBarModes } from "../../utils/common.js";
import { useMeetingAppContext } from "../../MeetingAppContextDef.js";
import DownArrow from "./icons/Studentlist/DownArrow";

function ILSBottomBar(
  {
    meetingMode,
    localParticipantId,
    micAllowedParticipantsList,
    webcamAllowedParticipantsList,
    action
  }
) {
  
  const { setSideBarMode, meetingRecord } = useMeetingAppContext();

  const RaiseHandBTN = ({ isMobile, isTab }) => {

    return (
      <>
        {/* <OutlinedButton
        onClick={RaiseHand}
        tooltip={""}
        Icon={HandRaisedIcon}
        buttonText={"Raise Hand"}
      /> */}
        <div className={`ButtonOuter`} >
          {false ? <>
            <button><HandRaisedIcon /> <div className="ButtonName TextOrange">Raise Hand </div></button>
          </> : <><button><HandRaisedIconOff /> <div className="ButtonName TextGrey">Raise Hand </div></button>
          </>}
        </div>
      </>
    );
  };



  // const audioTrackRef = useRef();
  const [mics, setMics] = useState([]);
  const [openMicList, setOpenMicList] = useState(false);


  const getAudioDevices = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });

      const devices = await navigator.mediaDevices.enumerateDevices();

      const mics = devices.filter((device) => {
        const label = device?.label?.toLowerCase() || '';
        return (
          device.kind === 'audioinput' &&
          !label.includes('default') &&
          !label.includes('monitor') &&
          !label.includes('virtual') &&
          !label.includes('stereo mix') &&
          !label.includes('communications') &&
          device.deviceId !== 'default' &&
          device.deviceId !== 'communications'
        );
      });

      const uniqueMics = [];
      const seenLabels = new Set();

      mics.forEach(mic => {
        const baseLabel = mic.label.replace(/\(.*?\)/g, '')
          .replace(/[0-9]/g, '')
          .trim();

        if (!seenLabels.has(baseLabel)) {
          seenLabels.add(baseLabel);
          uniqueMics.push(mic);
        }
      });

      console.log("All detected mics:", devices.filter(d => d.kind === 'audioinput'));
      console.log("Filtered Mics:", uniqueMics);

      setMics(uniqueMics); // Or use mics if you want to keep all variants
    } catch (err) {
      console.log("Error in getting audio devices", err);
    }
  };






  const MicBTN = ({ isMobile, isTab }) => {
    const mMeeting = useMeeting();
    const localMicOn = mMeeting?.localMicOn;
    // const changeMic = mMeeting?.changeMic;


    // const dropDownRefMic = useRef(null);



    return (
      <>
        <div className={`ButtonOuter`} style={{ marginRight: "0" }} onClick={() => {

          mMeeting.toggleMic();

        }}>
          {localMicOn ? <>
            <div className="MuteUnmuteBtnDiv" >
              <div className="MuteUnmuteBtnInner" style={{ minWidth: "64px" }}>
                <MicOnIcon /> <div className="ButtonName TextOrange">Mute</div>
              </div>

            </div>
          </> : <><div className="MuteUnmuteBtnDiv" >
            <div className="MuteUnmuteBtnInner" style={{ minWidth: "64px" }}>
              <img src={MicUnmuteOrange} alt="MicUnmuteOrange" /> <div className="ButtonName TextOrange">Unmute</div>
            </div>


          </div>

          </>}
        </div>
        <div className={`downArrow ${openMicList ? "UpSide" : "DownSide"}`} onClick={() => {
          console.log("lskdfjlkj", openMicList)
          setOpenMicList(!openMicList)
        }}><DownArrow /></div>
      </>
    );
  };

  const [isLoading, setIsLoading] = useState(false);

  const WebCamBTN = React.memo(({ isMobile, isTab }) => {
    const mMeeting = useMeeting();


    const localWebcamOn = mMeeting?.localWebcamOn;

    return (
      <>
        <div className="Btnport">
          <div
            className={`ButtonOuter ${isLoading ? 'disabled' : ''}`}
            style={{ marginLeft: "15px" }}
          // onClick={isLoading ? undefined : handleToggleWebcam}
          >
            {isLoading ? (
              <button style={{ minWidth: "64px" }}>
                <span className="webcameOnBar">
                  {/* <Spin /> */}
                </span>
                <div className="ButtonName TextGrey">Loading...</div>
              </button>
            ) : localWebcamOn ? (
              <button style={{ minWidth: "64px" }}>
                <span className="webcameOnBar"><WebcamOnIcon /></span>
                <div className="ButtonName TextOrange">Stop Video</div>
              </button>
            ) : 
            (
              <button style={{ minWidth: "64px" }}>
                <span className="webcameOnBar">
                  <img src={UnmuteVideo} alt="UnmuteVideo" />
                </span>
                <div className="ButtonName TextGrey">Start Video</div>
              </button>
            )}
          </div>


        </div>
      </>
    );
  });

  const { presenterId } = useMeeting();

  useEffect(() => {
    if (presenterId) {
      setSideBarMode(null)

    } else {
      if (!isMobile) { setSideBarMode(sideBarModes.CHAT) }


    }
  }, [presenterId])


  const LeaveBTN = () => {


    return (
      <>
        <button className="EndClass" >
          End Class
        </button>


      </>
    );
  };



  const [openMoreItem, setOpenMoreItem] = useState(false)
  const [modalOpen1, setModalOpen1] = useState(false);



  const MoreButton = memo(() => {

    const dropDownRef = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
          setOpenMoreItem(false);
        }
      };

      if (openMoreItem) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [openMoreItem]);


    return (
      <>
        <div className="ButtonOuter">
          <button onClick={() => {
            setOpenMoreItem(!openMoreItem)
          }}>
            {openMoreItem ? <><MoreIcon />
              <p class="ButtonName MoremenuName">More</p></> : <><MoreIconOff />
              <p class="ButtonName MoremenuName TextGrey">More</p></>}

          </button>
          {<div className="MoreDropDown"
            style={openMoreItem ? {} : { "display": "none" }}
            ref={dropDownRef}
          >
            <div className="DropItems" onClick={() => { setModalOpen1(true); setOpenMoreItem(false) }}> Report Issue</div>
            {/* <div className="DropItems" onClick={() => {setResOpen(true);setOpenMoreItem(false)}}> Set Video Resolution</div> */}
            {/* <div className="DropItems" onClick={() => setSettingModalOpen(true)}> Settings</div> */}
          </div>}
        </div>
      </>
    )
  })


  const { networkStrengthOfParticipants } = useMeetingAppContext();
  const networkStrengthRef = useRef(networkStrengthOfParticipants);

  console.log("checking meeting record in ils container", meetingRecord?.lecture_host_id_string)

  useEffect(() => {
    networkStrengthRef.current = networkStrengthOfParticipants;
  }, [networkStrengthOfParticipants]);


  const emojiPanel = () => {
    return (

      <div className="EmojiDropDown" ref={dropDownRefReaction}>
        <div className="EmojiIcons" >😂</div>

        <div className="EmojiIcons"
        >🎉</div>
        <div className="EmojiIcons" 
        >👍</div>
        <div className="EmojiIcons"
        >🔥</div>

      </div>

    )
  }

  const [openEmojiPanel, setOpenEmojiPanel] = useState(false);
  const dropDownRefReaction = useRef(null);


  const ReactionBTN = ({ isMobile, isTab }) => {
    return (<>
      <div className="EmojiOuter">
        <div className={`ButtonOuter`}
          onClick={() => setOpenEmojiPanel(!openEmojiPanel)}
        >
          {openEmojiPanel ? <>
            <button><SmileyIcon /> <div className="ButtonName TextOrange">Reactions</div></button>
          </> : <><button><SmileyIconOff /> <div className="ButtonName TextGrey">Reactions</div></button>

          </>}
        </div>
      </div>
    </>);
  };



  const tollTipEl = useRef();
  const isMobile = false;
  const isTab = false;


  const BottomBarButtonTypes = useMemo(
    () => ({
      END_CALL: "END_CALL",
      CHAT: "CHAT",
      PARTICIPANTS: "PARTICIPANTS",
      SCREEN_SHARE: "SCREEN_SHARE",
      WEBCAM: "WEBCAM",
      MIC: "MIC",
      RAISE_HAND: "RAISE_HAND",
      RECORDING: "RECORDING",
      MEETING_ID_COPY: "MEETING_ID_COPY",
      HLS: "HLS",
      POLL: "POLL",
      REACTION: "REACTION",
      ECOMMERCE: "ECOMMERCE",
    }),
    []
  );

  const otherFeatures = [
    { icon: BottomBarButtonTypes.RAISE_HAND },
    { icon: BottomBarButtonTypes.CHAT },
    { icon: BottomBarButtonTypes.PARTICIPANTS },
    { icon: BottomBarButtonTypes.MEETING_ID_COPY },
    { icon: BottomBarButtonTypes.POLL },
    { icon: BottomBarButtonTypes.REACTION },
    { icon: BottomBarButtonTypes.ECOMMERCE },
  ];

  if (meetingMode === Constants.modes.CONFERENCE) {
    otherFeatures.pop({ icon: BottomBarButtonTypes.REACTION });
    otherFeatures.push({ icon: BottomBarButtonTypes.SCREEN_SHARE });
    otherFeatures.push({ icon: BottomBarButtonTypes.HLS });
  }


//recording start event and participant joins in the depenendency array...

  return (
    <>
      <div className="BottomBarNav">
        <div className="flex flex-1 items-center justify-center column" ref={tollTipEl}>
          <div className="LeftBottomBarNav">
            {((meetingMode === Constants.modes.CONFERENCE && false) ||
              micAllowedParticipantsList?.includes(localParticipantId)) ? <div className="Btnport MicBTNPort">
              <MicBTN isMobile={isMobile} isTab={isTab} /></div> :

              <>
                <div className={`ButtonOuter`} >
                  <button><MicOffIcon /> <div className="ButtonName TextGrey">Unmute</div></button>
                </div>
              </>

            }

            {((meetingMode === Constants.modes.CONFERENCE && false) || !webcamAllowedParticipantsList?.includes(localParticipantId)) ?
              <WebCamBTN /> :
              <>
                <div className={`ButtonOuter`}>
                  <button><img src={WebcamOffIcon} alt="WebcamOffIcon" /> <div className="ButtonName TextGrey">Start Video</div></button>
                </div>
              </>

            }

          </div>
          <div className="RightBottomBarNav">


            {<RaiseHandBTN isMobile={isMobile} isTab={isTab} />}

            {<ReactionBTN isMobile={isMobile} isTab={isTab} />}

            {/* More Button */}
            <MoreButton />
            <LeaveBTN />
          </div>
        </div>
      </div>

      {openEmojiPanel && emojiPanel()}


    </>
  );
}

export default React.memo(ILSBottomBar);

